import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex cursor-pointer"
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  key: 1,
  class: "no-image-placeholder rounded",
  style: {"width":"100px","height":"100px"}
}
const _hoisted_4 = { class: "ms-7" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "text-blue ms-2 font-bold" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "mt-2 font-bold" }

import { computed } from 'vue'
import { format } from 'date-fns'
import CoursePurchaseModel from '../../../api/v2/models/course_purchase'


export default /*@__PURE__*/_defineComponent({
  __name: 'CoursePurchase',
  props: {
    coursePurchase: {}
  },
  setup(__props: any) {

const props = __props

const dateFormat = (date: Date) => {
  return format(date, 'YYYY/MM/DD')
}

const hasImage = computed(() => {
  return !!props.coursePurchase.courseUrl
})

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (__props.coursePurchase)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (hasImage.value)
            ? (_openBlock(), _createBlock(_component_v_img, {
                key: 0,
                "min-height": "100",
                "min-width": "100",
                "max-height": "100",
                "max-width": "100",
                src: __props.coursePurchase.courseUrl,
                class: "rounded"
              }, null, 8 /* PROPS */, ["src"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_icon, {
                  size: "large",
                  color: "grey"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-image-off", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (__props.coursePurchase.isStoped)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  class: "text-white",
                  color: "red",
                  small: "",
                  label: ""
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" 終了 ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (__props.coursePurchase.isDone)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 1,
                  class: "text-white",
                  color: "green",
                  small: "",
                  label: ""
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" アクティブ ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (__props.coursePurchase.isPending)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 2,
                  class: "text-white",
                  color: "red",
                  small: "",
                  label: ""
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" 未払い ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_6, _toDisplayString(__props.coursePurchase.courseName), 1 /* TEXT */)
          ]),
          _createElementVNode("div", {
            class: "mt-2 text-gray white-space-pre-line",
            innerHTML: __props.coursePurchase.courseDescription
          }, null, 8 /* PROPS */, _hoisted_7),
          _createElementVNode("div", _hoisted_8, _toDisplayString(__props.coursePurchase.paiedPrice ? __props.coursePurchase.paiedPrice.toLocaleString() : 0) + "円 ", 1 /* TEXT */)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})